export const winnerCommunicationModules = ['email', 'claim-my-prize', 'no-communication'] as const;

export type WinnerCommunicationModule = (typeof winnerCommunicationModules)[number];
